import { CerebroDrawer } from '../../../shared/components';
import { TermSheetFacility } from '../../../shared/models';
import { FacilityForm } from './FacilityForm';

interface EditFacilityDrawerProps {
	dealGuid: string | undefined;
	dataRoomGuid: string | undefined;
	termSheetGuid: string | undefined;
	revisionGuid: string | undefined;
	facility: TermSheetFacility | null;
	close: () => void;
}

export const EditFacilityDrawer: React.FC<EditFacilityDrawerProps> = ({
	dealGuid,
	dataRoomGuid,
	termSheetGuid,
	revisionGuid,
	facility,
	close,
}) => {
	return (
		<CerebroDrawer open={facility != null} onClose={close}>
			<FacilityForm
				dealGuid={dealGuid}
				dataRoomGuid={dataRoomGuid}
				termSheetGuid={termSheetGuid}
				revisionGuid={revisionGuid}
				facility={facility}
				close={close}
			/>
		</CerebroDrawer>
	);
};
